import BaseLayout from './components/BaseLayout.vue';
import IndexPage from './components/IndexPage.vue';

const routes = [
  { path: '/', component: BaseLayout },
  { path: '/', component: IndexPage }

];

export default routes;
